export default __webpack_public_path__ + "dist/media/Rocket.e8cbb47c.svg";